import classNames from 'classnames'
import React from 'react'
import { VideoStart } from '@yy/one-icon'
import { useTranslation } from '../../../hooks'
import styles from './index.module.less'
import Tooltip from './Tooltip'

const BtnRecord: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  const { t } = useTranslation()
  return (
    <div>
      <Tooltip title={t('feedback.start')}>
        <div className={classNames(styles.btn, styles.recordBtn)} {...props}>
          <VideoStart origin />
        </div>
      </Tooltip>
    </div>
  )
}

export default BtnRecord
